module.exports = __webpack_public_path__ + "static/background-6237fa32cb49f79436b4b456d4a84ae4.jpg";